import { Button, Stack, TextField } from "@mui/material";
import { useMemo, useRef, useState } from "react";
import { useDynamicPagesContext } from "../../../../context/dynamic-pages-context";
import JoditEditor from "jodit-react";

const AddDynamicPage = () => {
  const { addPageData, types } = useDynamicPagesContext();
  const [description, setDescription] = useState();

  const [data, setData] = useState({
    title: "",
    description: "",
    type: "",
    meta_title: "",
    meta_description: "",
    meta_keywords: "",
  });
  const editor = useRef(null);
  const config = {
    uploader: {
      insertImageAsBase64URI: true,
    },
    height: 420,
    triggerChangeEvent: true,
    readonly: false,
  };

  const Jodit = () => {
    return useMemo(
      () => (
        <JoditEditor
          ref={editor}
          config={config}
          value={description}
          onChange={(e) => setDescription(e)}
        />
      ),
      [data]
    );
  };

  const storePageData = async () => {
    const formData = new FormData();
    formData.append("title", data.title);
    formData.append("description", description);
    formData.append("dynamic_page_type", data.type);
    formData.append("meta_title", data.meta_title);
    formData.append("meta_description", data.meta_description);
    formData.append("meta_keywords", data.meta_keywords);

    await addPageData(formData);
  };

  return (
    <Stack spacing={2} width={600}>
      <TextField
        fullWidth
        label="Meta Title"
        onChange={(e) =>
          setData({
            ...data,
            meta_title: e.target.value,
          })
        }
        variant="outlined"
      />
      <TextField
        fullWidth
        label="Meta Description"
        onChange={(e) =>
          setData({
            ...data,
            meta_description: e.target.value,
          })
        }
        variant="outlined"
        multiline
        rows={4}
      />
      <TextField
        fullWidth
        label="Meta Keywords"
        onChange={(e) =>
          setData({
            ...data,
            meta_keywords: e.target.value,
          })
        }
        variant="outlined"
      />
      <TextField
        fullWidth
        label="Title"
        onChange={(e) =>
          setData({
            ...data,
            title: e.target.value,
          })
        }
        variant="outlined"
        required
      />
      <TextField
        select
        fullWidth
        label="Type"
        onChange={(e) => setData({ ...data, type: e.target.value })}
        SelectProps={{ native: true }}
        variant="outlined"
        required
      >
        <option selected disabled>
          --- select Page Type Here ---
        </option>
        {types.map((type) => (
          <option key={type.id} value={type.id}>
            {type.title}
          </option>
        ))}
      </TextField>
      {Jodit()}
      <Button onClick={storePageData} variant="contained" color="primary">
        Submit
      </Button>
    </Stack>
  );
};

export default AddDynamicPage;
